import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

import { API_URL } from '@/api/constants'
import { TrainingVideo } from '@/types/videos'

//Todo move to videos/types.ts
type VideosTrainingResponse = {
  videos: TrainingVideo[]
  languages: string[]
  tags: string[]
  include_quizzes: boolean
}

const getVideosTraining = async (token?: string) => {
  const url = `${API_URL}/training-videos/token/${token}`
  const { data } = await axios.get(url)

  return data
}

export const useVideosTraining = (token?: string) => {
  return useQuery<VideosTrainingResponse>({
    queryKey: ['video-trainings', token],
    queryFn: () => getVideosTraining(token),
    enabled: !!token,
  })
}
